import { UserManager, WebStorageStateStore } from 'oidc-client';
import { environment } from '@env';

let userManager = null;
let callbackUserManager = null;

const createUserManager = (): UserManager => {
  return new UserManager({
    authority: environment.AUTH_URL,
    client_id: environment.CLIENT_ID,
    redirect_uri: `${window.location.origin}/auth/login`,
    acr_values: 'external_idp:enabled',
    // these two will be done dynamically from the buttons clicked, but are
    // needed if you want to use the silent_renew
    response_type: 'code',
    scope: 'openid profile email basic_profile unit_profile smg_profile vention_mg_api',
    // this will toggle if profile endpoint is used
    loadUserInfo: true,
    // silent renew will get a new access_token via an iframe
    // just prior to the old access_token expiring (60 seconds prior)
    silent_redirect_uri: `${window.location.origin}/auth/refresh`,
    automaticSilentRenew: true,
    // this will allow all the OIDC protocol claims to be visible in the window. normally a client app
    // wouldn't care about them or want them taking up space
    filterProtocolClaims: false,
    userStore: new WebStorageStateStore({ store: localStorage }),
  });
};

const createCallbackUserManager = () =>
  new UserManager({
    authority: environment.AUTH_URL,
    client_id: environment.CLIENT_ID,
    monitorSession: false,
    userStore: new WebStorageStateStore({ store: localStorage }),
  });

export const getCallbackUserManager = (): UserManager => {
  if (!callbackUserManager) {
    callbackUserManager = createCallbackUserManager();
  }

  return callbackUserManager;
};

export const getUserManager = (): UserManager => {
  if (!userManager) {
    userManager = createUserManager();
  }

  return userManager;
};
